import styled, { css } from 'styled-components'
import { Container } from '../../atoms/GridSystem';

interface StyledProps {
  noGutter?: boolean;
  colorScheme?: string;
}

export const Tabs = styled.div<StyledProps>`
  // padding-top: ${({ theme }) => theme.rem(24)};
  // padding-bottom: ${({ theme }) => theme.rem(24)};
`

export const TabsButtons = styled(Container)<StyledProps>`
  display: flex;  
  justify-content: center;

  .swiper {
    width: 100%;
    margin: 0;
  }

  .swiper-wrapper {    
    ${({ theme }) => theme.mediaQuery.lg(`
      justify-content: center;  
    `)}
  }
  
  .swiper-slide {
    display: inline-flex;
    width: auto;
    padding: ${({ theme }) => theme.rem(8, 0)};
    
    &:last-child {
      margin-right: 0!important;
    }
  }

  button.tab-button {
    background-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.bgDefault};
    border-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.borderDefault};
    
    > * {
      color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.textDefault};
    }

    &:hover {
      background-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.bgHover};
      border-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.borderHover};
      
      > * {
        color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.textHover};
      }
    }

    &:active {
      background-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.bgPressed};
      border-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.borderPressed};
      
      > * {
        color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.unselected.textPressed};
      }
    }

    &[aria-current="true"] {
      background-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.bgDefault};
      border-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.borderDefault};
      
      > * {
        color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.textDefault};
      }

      &:hover {
        background-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.bgHover};
        border-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.borderHover};
        
        > * {
          color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.textHover};
        }
      }

      &:active {
        background-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.bgPressed};
        border-color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.borderPressed};
        
        > * {
          color: ${({ theme, colorScheme }) => colorScheme && theme.colorScheme[colorScheme].tabs.selected.textPressed};
        }
      }
    }
  }
`

export const TabsBorder = styled.div<StyledProps>`
  max-width: 100%;
  padding: ${({ theme }) => theme.rem(8)};
  border-radius: ${({ theme }) => theme.rem(8)};
  border: 1px solid #D8D8D8;
`